import { useWindowWidth } from './useWindowWidth'

/** Returns true when the viewport is below Tailwind's `md` breakpoint (768 px). */
export function useIsMobile(): boolean {
  return useWindowWidth() < 768
}
